module.exports = __webpack_public_path__ + "img/TAMBOV.30241715.png";